<form
  id="informations-client-form"
  class="px-4"
  [formGroup]="localActiviteForm"
>
  <div class="d-flex justify-content-between mb-5">
    <div class="col-4">
      <p-input
        [formControl]="localActiviteForm.controls.propertyType"
        id="propertyType"
        name="propertyType"
        label="Type de bien"
        [disabled]="true"
      ></p-input>
    </div>

    <div class="col-4">
      <p-input
        [formControl]="localActiviteForm.controls.constructionYear"
        id="constructionYear"
        name="constructionYear"
        label="Année de construction"
        [maxLengthNumber]="4"
        (input)="onConstructionYearChanged($event)"
        type="number"
        errorMessage="L'année de construction doit être un nombre à 4 chiffres."
      ></p-input>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-input
        [formControl]="localActiviteForm.controls.areaM2"
        id="areaM2"
        name="areaM2"
        label="Surface"
        placeholder="Ex : 100"
        fixedText="m²"
        type="number"
        (input)="onAreaM2Changed($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="localActiviteForm.controls.nature"
        id="nature"
        name="nature"
        label="Nature"
        placeholder="Ex : bureaux"
        (input)="onNatureChanged($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="localActiviteForm.controls.numberOfParkingSpaces"
        type="number"
        id="numberOfParkingSpaces"
        name="numberOfParkingSpaces"
        label="Nb stationnements"
        placeholder="Ex : 10"
        (input)="onNumberOfParkingSpacesChanged($event)"
      ></p-input>
    </div>
  </div>

  <div class="mb-4 mt-4">
    <span class="form-label">Transport en commun à proximité</span>
    <div class="options_container">
      <div *ngFor="let option of transportOptions" class="">
        <div class="form-check">
          <input
            type="checkbox"
            [id]="option.value"
            [formControl]="getTransportControl(option.value)"
            class="form-check-input pointer"
            (change)="onTransportSelectionChanged()"
          />
          <label [for]="option.value" class="form-check-label pointer">
            {{ option.label }}
          </label>
        </div>
      </div>
    </div>
  </div>
</form>
